import UserSessions from "./UserSessions";
import { Routes, Route } from "react-router-dom";
import ViewSession from "./ViewSession";
import ContentLayout from "../../layout/ContentLayout";

const Sessions = () => {
  return (
    <>
      <ContentLayout>
        <Routes>
          <Route index element={<UserSessions />} />
          <Route path="/:sessionId" element={<ViewSession />} />
        </Routes>
      </ContentLayout>
    </>
  );
};

export default Sessions;
